import ChangelogBase from 'components/changelog-page/ChangelogBase'
import { graphql, useStaticQuery } from 'gatsby'
import { ReactElement } from 'react'
import getEnglishStrings from 'utils/getEnglishStrings'

export default function Ios(): ReactElement {
  const androidData = useStaticQuery<Queries.AndroidChangelogQuery>(graphql`
    query AndroidChangelog {
      directus {
        application_changelog {
          strings {
            languages_code {
              code
            }
            android_changelog_title
            android_changelog_meta_description
            android_changelog_meta_keywords
          }
        }
      }
    }
  `)

  const androidchangelogsStrings = getEnglishStrings(
    androidData.directus?.application_changelog?.strings,
  )

  return (
    <ChangelogBase
      metaData={{
        title: androidchangelogsStrings?.android_changelog_title,
        meta_description: androidchangelogsStrings?.android_changelog_meta_description,
        meta_keywords: androidchangelogsStrings?.android_changelog_meta_keywords,
      }}
      title={androidchangelogsStrings?.android_changelog_title ?? ''}
      platform="android"
    />
  )
}
